import React, { useState, useEffect } from "react";
import Colors from "../../../../stories/assets/Colors";
import Fonts from "../../../../stories/assets/Fonts";
import { Button } from "../../../../stories/Button/Button";
import {
  FolderIconBlue,
  ArrowUpRightBlue,
  AddIconGray,
  AddIconBlue,
} from "../../../../constant/imagePath";
import { Container } from "react-bootstrap";
import { BeforeLoginHeader } from "../../../../stories/BeforeLoginHeader/BeforeLoginHeader";
import { Row, Col } from "react-bootstrap";
import { LinkButtonWithIcon } from "../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon.jsx";
import classes from "./AddFaqMobile.module.css";
import Map from "../../../CustomMap/CustomMap";
import { Input } from "../../../../stories/Input/Input";
import { DropDown } from "../../../../stories/DropDown/DropDown";
import { TextArea } from "../../../../stories/TextArea/TextArea";
import { CommonQuestions } from "../../../../stories/CommonQuestions/CommonQuestions";
import AddQuestionModal from "../../../Modals/CoachFlow/OnBoarding/AddAQuestion/AddAQuestion";
import isShowPricingPolicy from "../../../Modals/CoachFlow/OnBoarding/HowDoesPricingWork/HowDoesPricingWork";
import HowDoesPricingWork from "../../../Modals/CoachFlow/OnBoarding/HowDoesPricingWork/HowDoesPricingWork";
import PageProgressBar from "../../../../stories/PageProgressBar/PageProgressBar";
import { useDispatch, useSelector } from "react-redux";
import { setPersonalData } from "../../../../store/Actions/authAction";

export default function AddFaqMobile({ stepForwardAndBackward }) {
  const dispatch = useDispatch();
  const getDataFromRedux = useSelector((state) => state.onBoardingReducer?.faq);

  const [faqData, setFaqData] = useState(
    getDataFromRedux ? getDataFromRedux : []
  );
  const [editingData, setEdititngData] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [isAdding, setIsAdding] = useState(false);

  function handleDelete(item) {
    const newFaqData = faqData?.slice();
    const index = newFaqData.findIndex((data) => data?._id === item?._id);
    newFaqData?.splice(index, 1);
    setFaqData(newFaqData);
  }
  function handleEdit(item) {
    setIsEditing(true);
    setEdititngData({
      _id: item?._id,
      answer: item?.description,
      question: { label: item?.title, value: item?.title },
    });
  }

  function editFaq(data) {
    console.log({ data });
    const newArr = [...faqData];
    const index = newArr?.findIndex((item) => item?._id == data?._id);
    newArr[index] = data;
    setFaqData(newArr);
  }
  console.log({ faqData });
  function addFaq(data) {
    setFaqData([...faqData, data]);
  }

  // Save And Finish Later
  function saveAndFinishLater() {
    dispatch(setPersonalData("faq", faqData));
  }

  return (
    <div className={classes.addFaq}>
      <div className={classes.progressLine}>
        <PageProgressBar progress={"66.6%"} />
      </div>

      <Row className={`g-0 ${classes.row}`}>
        <Col md={12} className={` ${classes.innerContainer}`}>
          <Col md={12} className={classes.mt32}>
            <h3
              style={{
                ...Fonts.h3,
                color: Colors.neutralShadesOfNero,
              }}
            >
              Add FAQ
            </h3>

            <p
              className={classes.oneOnOne}
              style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}
            >
              1-on-1 lesson
            </p>
          </Col>
          {faqData?.length > 0 && (
            <Col md={12} className={classes.mt24}>
              <CommonQuestions
                data={faqData?.map((item) => ({
                  _id: item?._id,
                  title: item?.question,
                  description: item?.answer,
                }))}
                btnsPosition={"Bottom"}
                handleDelete={handleDelete}
                handleEdit={handleEdit}
              />
            </Col>
          )}

          <Col md={12} className={classes.addMoreBtnBox}>
            <LinkButtonWithIcon
              text={"Add a question"}
              primary={true}
              leftIcon={AddIconBlue}
              iconStyle={{
                marginRight: "10px",
              }}
              customStyle={{ ...Fonts.b2 }}
              onClick={() => setIsAdding(true)}
            />
          </Col>
        </Col>
        <Col
          md={12}
          style={{
            borderTop: `1px solid ${Colors.neutralShadesOfGainsboro}`,
          }}
          className={classes.btnsCol}
        >
          <div className={classes.btnsBox}>
            <LinkButtonWithIcon
              text={"Go Back"}
              customStyle={{
                ...Fonts.b2,
                lineHeight: "20px",
                height: "56px",
              }}
              onClick={() => stepForwardAndBackward(2, 2)}
            />

            <Button
              label={"Next"}
              primary={true}
              size={"Large"}
              customStyle={{ width: "162px", height: "56px", margin: "0px" }}
              onClick={() => {
                saveAndFinishLater();
                stepForwardAndBackward(2, 4);
              }}
            />
          </div>
        </Col>
      </Row>

      {isAdding && (
        <AddQuestionModal
          show={isAdding}
          setShow={setIsAdding}
          onAdd={addFaq}
        />
      )}
      {isEditing && (
        <AddQuestionModal
          show={isEditing}
          setShow={setIsEditing}
          isEditing
          onAdd={editFaq}
          data={editingData}
        />
      )}
    </div>
  );
}
